// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning__3f6Im","warningBox":"warningBox__3XTTO"};